/**
 * #/items-estandar: ENLACE VIEJO (CATALOGO-UNICO-ITEMS-T1, Ares #43601).
 *
 * Josse (#43584): "es un error crear una nueva seccion que se llame items estandar teniendo ya mis items". El editor
 * del 699 vive ahora en "Tus items y precios" (componente CatalogoEstandar). Esta ruta ya no esta en el menu; si alguien
 * llega por un enlace guardado ve el mismo catalogo con el mismo titulo.
 *
 * AUDIENCIA: Josse y el asesor de Maderinco que llegan por un enlace viejo, en escritorio o celular, solo el negocio demo.
 *
 * @module presentation/views/ItemEstandarView
 */
import { montarCatalogoEstandar } from '../components/presupuestos/CatalogoEstandar.js';
import { regresoHtml } from '../shared/regreso.js';

export async function renderItemEstandar(container) {
  if (!container) return;
  container.innerHTML = `${regresoHtml({ volverA: '#/presupuestos', texto: 'Presupuestos' })}<h1 style="margin:8px 0 4px">Tus ítems y precios</h1>
    <div data-ie-catalogo></div>`;
  await montarCatalogoEstandar(container.querySelector('[data-ie-catalogo]'));
}
